/**
 * Time in lieu — the few sums the screens do themselves (DESIGN-toil.md, 20/10/2026).
 *
 * ⚠️ PREVIEW ONLY. The server decides what a claim is worth (`services/toil.given_minutes`)
 * and whether a booking fits (`services/toil.check_booking`); these exist so the approver
 * sees "Time and a half: 4h 30m" before pressing Approve, and must give the same answer.
 * `toil.checks.mjs` pins them to the server's own examples.
 */

/** E2 — the fixed set, in the order the approver sees them. */
export const RATE_OPTIONS = [
  { value: '1', label: 'Straight time', short: '×1', factor: 1 },
  { value: '1.5', label: 'Time and a half', short: '×1.5', factor: 1.5 },
  { value: '2', label: 'Double time', short: '×2', factor: 2 },
  { value: 'custom', label: 'Enter it', short: '', factor: null },
];

export const RATE_WORDS = { '1': 'straight time', '1.5': 'time and a half', '2': 'double time',
  custom: 'a time entered by hand' };

/** '3h 30m' / '4h' / '45m' / '0h' / '-2h 15m' — the same words as services/toil.fmt. */
export function fmtToil(minutes) {
  const total = Math.round(Number(minutes) || 0);
  const sign = total < 0 ? '-' : '';
  const abs = Math.abs(total);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  if (h && m) return `${sign}${h}h ${m}m`;
  if (h) return `${sign}${h}h`;
  if (m) return `${sign}${m}m`;
  return '0h';
}

/** Hours and minutes boxes -> minutes, or null when nothing usable was typed. */
export function toMinutes(hours, minutes) {
  const h = hours === '' || hours == null ? 0 : Number(hours);
  const m = minutes === '' || minutes == null ? 0 : Number(minutes);
  if (!Number.isFinite(h) || !Number.isFinite(m) || h < 0 || m < 0) return null;
  const total = Math.round(h * 60 + m);
  return total > 0 ? total : null;
}

/** The time given back for `worked` minutes at `rate` — null for "Enter it" with nothing entered. */
export function givenMinutes(worked, rate, customMinutes) {
  if (rate === 'custom') return customMinutes && customMinutes > 0 ? customMinutes : null;
  const opt = RATE_OPTIONS.find((o) => o.value === rate);
  if (!opt || !worked) return null;
  return Math.round(worked * opt.factor);
}
